/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as ComboboxActions } from './combobox-actions.story';
export { default as ComboboxAsync } from './combobox-async.story';
export { default as ComboboxClean } from './combobox-clean.story';
export { default as ComboboxActionOnSelect } from './combobox-action-on-select.story';
export { default as ComboboxCreatable } from './combobox-creatable.story';
export { default as ComboboxCustomMulti } from './combobox-custom-multi.story';
export { default as ComboboxCustomSingle } from './combobox-custom-single.story';
export { default as ComboboxCustomTrigger } from './combobox-custom-trigger.story';
export { default as ComboboxDefault } from './combobox-default.story';
export { default as ComboboxDescriptions } from './combobox-descriptions.story';
export { default as ComboboxDisabled } from './combobox-disabled.story';
export { default as ComboboxFluid } from './combobox-fluid.story';
export { default as ComboboxGroups } from './combobox-groups.story';
export { default as ComboboxHiddenLabel } from './combobox-hidden-label.story';
export { default as ComboboxIcons } from './combobox-icons.story';
export { default as ComboboxInDialog } from './combobox-in-dialog.story';
export { default as ComboboxInPopover } from './combobox-in-popover.story';
export { default as ComboboxInPopoverDialog } from './combobox-in-popover-dialog.story';
export { default as ComboboxLargeDataSet } from './combobox-large-data-set.story';
export { default as ComboboxMaxRows } from './combobox-max-rows.story';
export { default as ComboboxMulti } from './combobox-multi.story';
export { default as ComboboxNativeForm } from './combobox-native-form.story';
export { default as ComboboxSelectOnly } from './combobox-select-only.story';
export { default as ComboboxSizes } from './combobox-sizes.story';
export { default as ComboboxUnlimitedRows } from './combobox-unlimited-rows.story';
export { default as ComboboxValidation } from './combobox-validation.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import ComboboxActionOnSelectSourceRaw from './combobox-action-on-select.story.tsx?raw';
import ComboboxActionsSourceRaw from './combobox-actions.story.tsx?raw';
import ComboboxAsyncSourceRaw from './combobox-async.story.tsx?raw';
import ComboboxCleanSourceRaw from './combobox-clean.story.tsx?raw';
import ComboboxCreatableSourceRaw from './combobox-creatable.story.tsx?raw';
import ComboboxCustomMultiSourceRaw from './combobox-custom-multi.story.tsx?raw';
import ComboboxCustomSingleSourceRaw from './combobox-custom-single.story.tsx?raw';
import ComboboxCustomTriggerSourceRaw from './combobox-custom-trigger.story.tsx?raw';
import ComboboxDefaultSourceRaw from './combobox-default.story.tsx?raw';
import ComboboxDescriptionsSourceRaw from './combobox-descriptions.story.tsx?raw';
import ComboboxDisabledSourceRaw from './combobox-disabled.story.tsx?raw';
import ComboboxFluidSourceRaw from './combobox-fluid.story.tsx?raw';
import ComboboxGroupsSourceRaw from './combobox-groups.story.tsx?raw';
import ComboboxHiddenLabelSourceRaw from './combobox-hidden-label.story.tsx?raw';
import ComboboxIconsSourceRaw from './combobox-icons.story.tsx?raw';
import ComboboxInDialogSourceRaw from './combobox-in-dialog.story.tsx?raw';
import ComboboxInPopoverSourceRaw from './combobox-in-popover.story.tsx?raw';
import ComboboxInPopoverDialogSourceRaw from './combobox-in-popover-dialog.story.tsx?raw';
import ComboboxLargeDataSetSourceRaw from './combobox-large-data-set.story.tsx?raw';
import ComboboxMaxRowsSourceRaw from './combobox-max-rows.story.tsx?raw';
import ComboboxMultiSourceRaw from './combobox-multi.story.tsx?raw';
import ComboboxNativeFormSourceRaw from './combobox-native-form.story.tsx?raw';
import ComboboxSelectOnlySourceRaw from './combobox-select-only.story.tsx?raw';
import ComboboxSizesSourceRaw from './combobox-sizes.story.tsx?raw';
import ComboboxUnlimitedRowsSourceRaw from './combobox-unlimited-rows.story.tsx?raw';
import ComboboxValidationSourceRaw from './combobox-validation.story.tsx?raw';

export const ComboboxActionsSource = removeLicenseHeader(
  ComboboxActionsSourceRaw,
);

export const ComboboxAsyncSource = removeLicenseHeader(ComboboxAsyncSourceRaw);

export const ComboboxCleanSource = removeLicenseHeader(ComboboxCleanSourceRaw);

export const ComboboxActionOnSelectSource = removeLicenseHeader(
  ComboboxActionOnSelectSourceRaw,
);

export const ComboboxCreatableSource = removeLicenseHeader(
  ComboboxCreatableSourceRaw,
);

export const ComboboxDefaultSource = removeLicenseHeader(
  ComboboxDefaultSourceRaw,
);

export const ComboboxDescriptionsSource = removeLicenseHeader(
  ComboboxDescriptionsSourceRaw,
);

export const ComboboxDisabledSource = removeLicenseHeader(
  ComboboxDisabledSourceRaw,
);

export const ComboboxFluidSource = removeLicenseHeader(ComboboxFluidSourceRaw);

export const ComboboxGroupsSource = removeLicenseHeader(
  ComboboxGroupsSourceRaw,
);

export const ComboboxHiddenLabelSource = removeLicenseHeader(
  ComboboxHiddenLabelSourceRaw,
);

export const ComboboxIconsSource = removeLicenseHeader(ComboboxIconsSourceRaw);

export const ComboboxInDialogSource = removeLicenseHeader(
  ComboboxInDialogSourceRaw,
);

export const ComboboxInPopoverSource = removeLicenseHeader(
  ComboboxInPopoverSourceRaw,
);

export const ComboboxInPopoverDialogSource = removeLicenseHeader(
  ComboboxInPopoverDialogSourceRaw,
);

export const ComboboxLargeDataSetSource = removeLicenseHeader(
  ComboboxLargeDataSetSourceRaw,
);

export const ComboboxMaxRowsSource = removeLicenseHeader(
  ComboboxMaxRowsSourceRaw,
);

export const ComboboxMultiSource = removeLicenseHeader(ComboboxMultiSourceRaw);

export const ComboboxNativeFormSource = removeLicenseHeader(
  ComboboxNativeFormSourceRaw,
);

export const ComboboxSelectOnlySource = removeLicenseHeader(
  ComboboxSelectOnlySourceRaw,
);

export const ComboboxSizesSource = removeLicenseHeader(ComboboxSizesSourceRaw);

export const ComboboxUnlimitedRowsSource = removeLicenseHeader(
  ComboboxUnlimitedRowsSourceRaw,
);

export const ComboboxCustomTriggerSource = removeLicenseHeader(
  ComboboxCustomTriggerSourceRaw,
);

export const ComboboxCustomMultiSource = removeLicenseHeader(
  ComboboxCustomMultiSourceRaw,
);

export const ComboboxCustomSingleSource = removeLicenseHeader(
  ComboboxCustomSingleSourceRaw,
);

export const ComboboxValidationSource = removeLicenseHeader(
  ComboboxValidationSourceRaw,
);
